import React, { useState } from 'react';
import DropzoneComponent from 'react-dropzone-component';

const Dropzone = ({
  uploadUrl,
  slotsRemaining,
  onSuccess,
  onError,
  dzParams,
  maxFileSize,
}) => {
  const [inProgress, setInProgress] = useState(false);

  let myDropzone;

  const maxFileSizeInMB = Math.floor(maxFileSize / 1048576);

  const djsConfig = {
    acceptedFiles:
      'image/jpeg,image/jpg,image/png,image/heic,image/heif,image/heic-sequence,image/webp',
    chunking: true,
    forceChunking: true,
    chunkSize: 220000,
    maxFilesize: maxFileSizeInMB,
    createImageThumbnails: false,
    clickable: '#dzClickable',
    dictFileTooBig: `File should be smaller than" ${maxFileSizeInMB}MB.`,
    params(files, xhr, chunk) {
      if (chunk) {
        Object.assign(dzParams, {
          name: chunk.file.name,
          chunk: chunk.index,
          chunks: chunk.file.upload.totalChunkCount,
        });
      }
      return dzParams;
    },
    chunksUploaded(file, done) {
      onSuccess(file, JSON.parse(file.xhr.response));
      done();
    },
  };

  const componentConfig = {
    postUrl: uploadUrl,
  };

  djsConfig.maxFiles = slotsRemaining;

  const processing = (file) => setInProgress(true);

  const success = (file, res) => myDropzone.removeFile(file);

  const error = (file, errorMessage) => onError(file, errorMessage);

  const complete = (file) => {
    setInProgress(false);
    onSuccess(JSON.parse(file.xhr.response));
  };

  const eventHandlers = {
    init: function(dz) {
      myDropzone = dz;
    },
    processing,
    success,
    error,
    complete,
  };

  return (
    <>
      <button
        className="button button--secondary"
        id="dzClickable"
        type="button"
        disabled={inProgress}
      >
        {inProgress ? (
          <span className="photo-button-icon">
            <i className="far fa-spinner fa-pulse"></i>
          </span>
        ) : (
          'Add photo'
        )}
      </button>
      <DropzoneComponent
        config={componentConfig}
        eventHandlers={eventHandlers}
        djsConfig={djsConfig}
      />
    </>
  );
};

export default Dropzone;
